import React from 'react'
import './divider.scss'

function Divider (props) {
  const getSizeClass = () => {
    if (typeof props.size === 'number' && props.size > 0 && props.size < 7) {
      return `pg-my-${props.size}`
    }

    return 'pg-my-1'
  }

  let classes = 'element-divider ' + getSizeClass()
  if (props.noLine || props.noline) {
    classes += ' element-divider__noLine'
  }

  if (props.vertical) {
    classes += ' element-divider__vertical'
  }

  return (
    <hr className={classes} />
  )
}

Divider.defaultProps = {
  noLine: false,
  vertical: false,
  size: 1
}

export default Divider



// WEBPACK FOOTER //
// ./src/app/shared/elements/divider/index.js